import { Directive, HostListener, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs'


@Directive({ selector: '[bindToSubject]' })
export class BindToSubjectDirective {
    @Input('bindToSubject') bindToSubject:Subject<any>;
    
    @HostListener('input', ['$event']) onChange(event) {
        this.bindToSubject.next(event.target.value);
    }

    subscription:Subscription;
    constructor(private el: ElementRef) {}

    ngOnInit() {
        this.subscription = this.bindToSubject.subscribe((value) => {
            var element = <HTMLInputElement> this.el.nativeElement;
            if (element.value !== value) element.value = value;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }


}


// WEBPACK FOOTER //
// ./web/static/services/directives/BindToSubject.ts